import eventTracking from './nav-event-tracking';
import migUhgTracking from './mig-uhg-tracking';
import feedHeadlineTracking from './feed-headline-tracking';
const env = window.env || 'production';
import miniScoreTracking from './mini-score-tracking';
const teamId = window.teamId !== 'milb' ? window.teamId : '000';
const reportingSuiteId = getReportingSuiteId();

window.trackAsync = function (asyncProps) {
    asyncTracking(asyncProps);
};

function getReportingSuiteId() {
    return env === 'production'
        ? `milbglobal,milb${teamId}`
        : `mlbdevmilbglobal${teamId === '000' ? '' : teamId}`;
}

function asyncTracking(asyncProps) {
    let CLEAR_VARS = [
        'eVar13',
        'prop25',
        'eVar28',
        'prop26',
        'prop27',
        'prop28',
        'prop29',
        'prop30',
        'prop32',
        'prop33',
        'prop34',
        'prop43',
        'prop49',
        'eVar49',
        'prop54',
    ];

    let clearVars = function (s) {
        CLEAR_VARS.forEach(function (prop) {
            delete s[CLEAR_VARS[prop]];
        });
        delete s.events;
    };

    var s = window.s_gi(reportingSuiteId);

    s.clearVars();
    clearVars(s);
    s.eVar73 = reportingSuiteId;
    s = Object.assign(s, asyncProps);

    // async call only on demand
    if (asyncProps) {
        s.tl(true, 'o', 'page loading');
    }
}

class Tracking {
    pageTracker() {
        const trackingObject = {};

        // track initial page view
        window.trackPageView(trackingObject);

        // track page load time
        window.addEventListener('load', function () {
            var end = window.performance.timing.loadEventStart;
            var start = window.performance.timing.navigationStart;
            var load = (end - start) / 1000;

            if (!isNaN(load) && load > 0) {
                window.trackAsync(
                    Object.assign({}, trackingObject, { prop66: load }),
                );
            }
        });
    }
}

export default new Tracking();
